module.exports = __webpack_public_path__ + "static/img/5.1a12f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/5.png
// module id = yMCt
// module chunks = 0